module.exports = __webpack_public_path__ + "img/login-information-sheetA.b17ab918.png";